module.exports = __webpack_public_path__ + "img/yusu.f2afba87.jpg";